<template>
	<div class="live-data-widget" v-show="!isUiTest">
		<div v-show="visible" class="widget-background"></div>
		<RealDataSub
			v-show="visible"
			class="widget-content p-a-1"
			ref="realData"
			:showForm="true"
			@panelChanged="panelChanged"
			@mockChanged="mockChanged"
			@infoShow="infoShow" />

		<div v-show="!visible" style="position:relative;z-index:3;">
			<button class="btn btn-xs btn-reversed-outline btn-show-hide-panel" @click="showPanel()"><span class="ico-arrow-left-sm"></span></button>
		</div>

		<Modal ref="infoModal" class="widget-modal" ariaLabelled="liveDataWidgetModal">
			<template #title>{{ title }}</template>
			<template #default>
				<p>
					{{ description }}
					<pre v-html="bookmarklet"></pre>
				</p>
			</template>
		</Modal>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import RealDataSub from './sub/RealDataSub.vue';
import Modal from '@/components/schreg-common/Modal.vue';
import { StateService } from '@/services/state.service';
import { Helpers } from '@/common/helpers';

export default defineComponent({
	name: 'LiveDataWidgetComponent',
	config: {
		key: 'schreg.liveDataWidget',
		devPath: 'live-data-widget',
		exported: false
	},
	components: {
		RealDataSub,
		Modal
	},
	data() {
		return {
			useMockData: true,
			bookmarklet: '',
			title: '',
			description: '',
			visible: true,
			isUiTest: false
		};
	},
	mounted() {
		const settings = StateService.getDevSettings();
		this.visible = settings ? settings.panelVisible : true;
		this.isUiTest = Helpers.isUiTest();
	},
	methods: {
		mockChanged(useMockData) {
			this.useMockData = useMockData;
		},
		infoShow(content) {
			this.bookmarklet = content.bookmarklet;
			this.title = content.title;
			this.description = content.description;
			this.$refs.infoModal.show();
		},
		showPanel() {
			this.visible = true;
			this.$refs.realData.setPanel(true);
		},
		panelChanged(visible) {
			this.visible = visible;
		}
	}
});
</script>

<style lang="scss" scoped>
.live-data-widget {
	position: relative;
	.widget-background {
		z-index: 1;
		background-color: rgba(255, 255, 255, 0.9);
		box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
		backdrop-filter: blur(4px);
		position: absolute;
		height: 100%;
		width: 100%;
		border: 2px solid rgba(0, 0, 0, 0.2);
		border-right: none;
		border-radius: 23px 0 0 23px;
	}
	.widget-content {
		z-index: 2;
		position: relative;
	}
	.widget-modal {
		z-index: 99;
	}
}
::v-deep .btn-show-hide-panel {
	position: absolute;
	top: 0.75rem;
	right: 0.75rem;
	span {
		line-height: 0;
	}
}
</style>
